(function() {
  if (window.__athleteStylesLoaded) return;
  window.__athleteStylesLoaded = true;

    function formatMoney(cents) {
      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
        const moneyFormat = theme.settings && theme.settings.moneyFormat ? theme.settings.moneyFormat : '$' + '{' + '{amount}' + '}';
        return theme.Currency.formatMoney(cents, moneyFormat);
      }

      return `$${(cents / 100).toFixed(2)}`;
    }

    function moneyText(cents) {
      const wrapper = document.createElement('div');
      wrapper.innerHTML = formatMoney(cents);
      return wrapper.textContent || wrapper.innerText || '';
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    function getReviewSummaryMarkup(reviewBadgeHtml) {
      if (!reviewBadgeHtml) return '';

      // Read the two data attributes straight off the badge string instead of
      // parsing untrusted metafield HTML into a DOM fragment.
      const badgeHtml = String(reviewBadgeHtml);
      if (!/jdgm-prev-badge/.test(badgeHtml)) return '';

      const ratingMatch = badgeHtml.match(/data-average-rating=['"]([^'"]*)['"]/);
      const countMatch = badgeHtml.match(/data-number-of-reviews=['"]([^'"]*)['"]/);
      const averageRating = Number((ratingMatch && ratingMatch[1]) || 0);
      const reviewCount = Number((countMatch && countMatch[1]) || 0);
      if (!averageRating || !reviewCount) return '';

      const ratingLabel = averageRating.toFixed(1);
      const countLabel = `(${reviewCount})`;
      const ariaLabel = `${ratingLabel} stars from ${reviewCount} ${reviewCount === 1 ? 'review' : 'reviews'}`;

      return `<span class="athlete-styles__review-badge" aria-label="${escapeHtml(ariaLabel)}"><svg class="athlete-styles__review-star" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M12 2.25 14.82 8l6.34.92-4.58 4.47 1.08 6.31L12 16.73 6.34 19.7l1.08-6.31L2.84 8.92 9.18 8 12 2.25Z"></path></svg><span class="athlete-styles__review-rating">${escapeHtml(ratingLabel)}</span><span class="athlete-styles__review-count">${escapeHtml(countLabel)}</span></span>`;
    }

    function parseJsonScript(scriptEl) {
      if (!scriptEl) return [];
      try {
        return JSON.parse(scriptEl.textContent || '[]');
      } catch (error) {
        return [];
      }
    }

    function getOptionValue(variant, index) {
      if (!variant) return '';
      if (index === 0) return variant.option1 || '';
      if (index === 1) return variant.option2 || '';
      if (index === 2) return variant.option3 || '';
      return Array.isArray(variant.options) ? (variant.options[index] || '') : '';
    }

    function findSizeOptionIndex(product) {
      const options = product && Array.isArray(product.options_with_values) ? product.options_with_values : [];

      for (let i = 0; i < options.length; i += 1) {
        const name = String(options[i].name || '').toLowerCase();
        if (name.includes('size')) return i;
      }

      return -1;
    }

    function isLengthOptionMeta(optionName, optionValue) {
      const normalizedName = String(optionName || '').toLowerCase();
      const normalizedValue = String(optionValue || '').toLowerCase();

      if (normalizedName.includes('length') || normalizedName.includes('leg') || normalizedName.includes('inseam')) {
        return true;
      }

      return ['short', 'regular', 'tall'].includes(normalizedValue);
    }

    function findLengthOptionIndex(product) {
      const options = product && Array.isArray(product.options_with_values) ? product.options_with_values : [];

      for (let i = 0; i < options.length; i += 1) {
        const option = options[i] || {};
        const name = option.name || '';
        const values = Array.isArray(option.values) ? option.values : [];

        if (String(name).toLowerCase().includes('length') || String(name).toLowerCase().includes('leg') || String(name).toLowerCase().includes('inseam')) {
          return i;
        }

        if (values.some((value) => isLengthOptionMeta(name, value))) {
          return i;
        }
      }

      return -1;
    }

      function getProductImage(product, variant) {
        return (variant && variant.featured_image && variant.featured_image.src) || (product && product.featured_image) || '';
      }

      function getSizedImageUrl(url, width) {
        if (!url) return '';

        try {
          const imageUrl = new URL(String(url), window.location.origin);
          imageUrl.searchParams.set('width', width);
          return imageUrl.toString();
        } catch (error) {
          return String(url);
        }
      }

      function getSizedImageSrcSet(url, widths) {
        if (!url || !Array.isArray(widths) || !widths.length) return '';

        return widths.map((width) => `${escapeHtml(getSizedImageUrl(url, width) || url)} ${width}w`).join(', ');
      }

      function preloadImage(src) {
        return new Promise((resolve) => {
          if (!src) {
            resolve();
            return;
          }

          const image = new Image();
          image.decoding = 'async';
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.src = src;
        });
      }

      const ATHLETE_HERO_WIDTHS = [416, 640, 832];
      const ATHLETE_HERO_SIZES = '(max-width: 749px) calc(100vw - 32px), 416px';
      const ATHLETE_THUMB_WIDTHS = [160, 240, 320];
      function preloadResponsiveImage(baseSrc, widths, sizesValue) {
        return new Promise((resolve) => {
          if (!baseSrc) {
            resolve();
            return;
          }

          const image = new Image();
          image.decoding = 'async';
          image.onload = () => resolve();
          image.onerror = () => resolve();
          image.sizes = sizesValue;
          image.srcset = getSizedImageSrcSet(baseSrc, widths);
          image.src = getSizedImageUrl(baseSrc, widths[widths.length - 1]) || baseSrc;
        });
      }

      function getProductImages(product, variant) {
        const images = [];
        const variantImage = variant && variant.featured_image && variant.featured_image.src ? variant.featured_image.src : '';

        if (variantImage) images.push(variantImage);

        if (product && Array.isArray(product.images)) {
          product.images.forEach((image) => {
            if (image && !images.includes(image)) images.push(image);
          });
        }

        const athleteImage = product && product.athlete_image ? product.athlete_image : '';
        if (athleteImage) images.push(athleteImage);

        return images;
      }

      function hydrateSlide(slideEl) {
        if (!slideEl || slideEl.dataset.athleteSlideHydrated === 'true') return;
        const img = slideEl.querySelector('img');
        if (!img) return;
        const src = img.dataset.slideSrc || slideEl.dataset.slideSrc;
        const srcset = img.dataset.slideSrcset || slideEl.dataset.slideSrcset;
        if (src) img.src = src;
        if (srcset) img.srcset = srcset;
        slideEl.dataset.athleteSlideHydrated = 'true';
      }

      function getCartUrl() {
        return (window.theme && theme.routes && theme.routes.cartPage) || '/cart';
      }

      // Product URLs come from embedded JSON and are always /products/<handle>.
      // Rebuild from a literal prefix + encoded handle so a poisoned value can
      // never carry a scheme or escape the products path.
      function getSafeProductUrl(url) {
        const match = String(url || '').match(/^\/products\/([^/?#]+)/);
        if (!match) return '#';
        try {
          return '/products/' + encodeURIComponent(decodeURIComponent(match[1]));
        } catch (error) {
          return '#';
        }
      }

    function initSection(sectionEl) {
      if (!sectionEl || sectionEl.dataset.athleteStylesInitialized === 'true') return;
      sectionEl.dataset.athleteStylesInitialized = 'true';

      const drawer = sectionEl.querySelector('[data-athlete-drawer]');
      const cardsScroller = sectionEl.querySelector('.athlete-styles__cards');
      const cardsNav = sectionEl.querySelector('[data-athlete-cards-nav]');
      const cardsPrevBtn = sectionEl.querySelector('[data-athlete-cards-prev]');
      const cardsNextBtn = sectionEl.querySelector('[data-athlete-cards-next]');
      const thumbs = sectionEl.querySelector('[data-athlete-thumbs]');
      const productMedia = sectionEl.querySelector('[data-athlete-product-media]');
      const productPlaceholder = sectionEl.querySelector('[data-athlete-product-placeholder]');
      const mediaNav = sectionEl.querySelector('[data-athlete-media-nav]');
      const mediaPrevBtn = sectionEl.querySelector('[data-athlete-media-prev]');
      const mediaNextBtn = sectionEl.querySelector('[data-athlete-media-next]');
      const mediaProgress = sectionEl.querySelector('[data-athlete-media-progress]');
      const fullLink = sectionEl.querySelector('[data-athlete-full-link]');
      const vendorEl = sectionEl.querySelector('[data-athlete-vendor]');
      const titleEl = sectionEl.querySelector('[data-athlete-title]');
      const reviewsEl = sectionEl.querySelector('[data-athlete-reviews]');
      const priceEl = sectionEl.querySelector('[data-athlete-price]');
      const lengthLabelEl = sectionEl.querySelector('[data-athlete-length-label]');
      const lengthsEl = sectionEl.querySelector('[data-athlete-lengths]');
      const sizeLabelEl = sectionEl.querySelector('[data-athlete-size-label]');
      const sizesEl = sectionEl.querySelector('[data-athlete-sizes]');
      const addBtn = sectionEl.querySelector('[data-athlete-add]');
      const cartLink = sectionEl.querySelector('[data-athlete-cart-link]');
      const clearAllBtn = sectionEl.querySelector('[data-athlete-clear-all]');
      const statusEl = sectionEl.querySelector('[data-athlete-status]');

      const cards = Array.from(sectionEl.querySelectorAll('[data-athlete-open]'));
      let currentProducts = [];
      let currentProductIndex = 0;
      let currentVariantId = '';
      let currentLengthValue = '';
      let currentSizeValue = '';
      let selectionByProductIndex = {};
      let addedItems = [];
      let cartTotalCents = null;
      let finalCartLinkVisible = false;
      let finalCartLinkTimer = null;
      let renderedProductMediaKey = '';
      let renderedProductMediaToken = 0;
      let mediaSlides = [];
      let mediaDots = [];
      let mediaSlideCenters = [];
      let mediaScrollFrame = null;
      let resizeFrame = null;
      let lastTrigger = null;

      function getFocusableElements() {
        if (!drawer) return [];

        return Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])'))
          .filter((element) => element.offsetParent !== null || element === document.activeElement);
      }

      function getMediaScrollStep() {
        if (!productMedia) return 0;

        const firstSlide = productMedia.querySelector('[data-athlete-product-slide]');
        if (!firstSlide) return productMedia.clientWidth;

        const styles = window.getComputedStyle(productMedia);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        const slideWidth = firstSlide.getBoundingClientRect().width;
        const slidesPerStep = Math.max(1, Math.floor((productMedia.clientWidth + gap) / (slideWidth + gap)));

        return (slideWidth + gap) * slidesPerStep;
      }

      function getCardsScrollStep() {
        if (!cardsScroller) return 0;

        const firstCard = cardsScroller.querySelector('.athlete-styles__card-shell');
        if (!firstCard) return cardsScroller.clientWidth;

        const styles = window.getComputedStyle(cardsScroller);
        const gap = parseFloat(styles.columnGap || styles.gap || 0);
        const cardWidth = firstCard.getBoundingClientRect().width;
        const cardsPerStep = Math.max(1, Math.floor((cardsScroller.clientWidth + gap) / (cardWidth + gap)));

        return (cardWidth + gap) * cardsPerStep;
      }

      function updateCardsArrows() {
        if (!cardsScroller || !cardsNav || !cardsPrevBtn || !cardsNextBtn) return;

        const isDesktop = window.innerWidth >= 750;
        const maxScrollLeft = cardsScroller.scrollWidth - cardsScroller.clientWidth;
        const hasOverflow = isDesktop && maxScrollLeft > 1;

        cardsNav.classList.toggle('is-active', hasOverflow);
        cardsPrevBtn.disabled = !hasOverflow || cardsScroller.scrollLeft <= 2;
        cardsNextBtn.disabled = !hasOverflow || cardsScroller.scrollLeft >= maxScrollLeft - 2;
      }

      function updateMediaArrows() {
        if (!productMedia || !mediaNav || !mediaPrevBtn || !mediaNextBtn) return;

        const isDesktop = window.innerWidth >= 750;
        const maxScrollLeft = productMedia.scrollWidth - productMedia.clientWidth;
        const hasOverflow = isDesktop && maxScrollLeft > 1;

        mediaNav.classList.toggle('is-active', hasOverflow);
        mediaPrevBtn.disabled = !hasOverflow || productMedia.scrollLeft <= 2;
        mediaNextBtn.disabled = !hasOverflow || productMedia.scrollLeft >= maxScrollLeft - 2;
      }

      function cacheMediaSlides() {
        mediaSlides = productMedia ? Array.from(productMedia.querySelectorAll('[data-athlete-product-slide]')) : [];
        mediaDots = mediaProgress ? Array.from(mediaProgress.children) : [];
        mediaSlideCenters = mediaSlides.map((slide) => slide.offsetLeft + (slide.offsetWidth / 2));
      }

      function resetMediaState() {
        mediaSlides = [];
        mediaDots = [];
        mediaSlideCenters = [];
      }

      function updateMediaProgress() {
        if (!productMedia || !mediaSlides.length || !mediaDots.length) return;

        const mediaCenter = productMedia.scrollLeft + (productMedia.clientWidth / 2);
        let activeIndex = 0;
        let smallestDistance = Infinity;

        mediaSlideCenters.forEach((slideCenter, index) => {
          const distance = Math.abs(slideCenter - mediaCenter);

          if (distance < smallestDistance) {
            smallestDistance = distance;
            activeIndex = index;
          }
        });

        mediaDots.forEach((dot, index) => dot.classList.toggle('is-active', index <= activeIndex));

        [activeIndex - 1, activeIndex, activeIndex + 1].forEach((idx) => {
          if (idx >= 0 && idx < mediaSlides.length) {
            hydrateSlide(mediaSlides[idx]);
          }
        });
      }

      function scheduleMediaScrollUpdate() {
        if (mediaScrollFrame) return;

        mediaScrollFrame = window.requestAnimationFrame(() => {
          mediaScrollFrame = null;
          updateMediaArrows();
          updateMediaProgress();
        });
      }

      function scheduleResizeUpdate() {
        if (resizeFrame) return;

        resizeFrame = window.requestAnimationFrame(() => {
          resizeFrame = null;
          cacheMediaSlides();
          updateMediaArrows();
          updateCardsArrows();
          updateMediaProgress();
        });
      }

      function getSelection(index = currentProductIndex) {
        const key = String(index);

        if (!selectionByProductIndex[key]) {
          selectionByProductIndex[key] = {
            variantId: '',
            lengthValue: '',
            sizeValue: ''
          };
        }

        return selectionByProductIndex[key];
      }

      function syncCurrentSelection(index = currentProductIndex) {
        const selection = getSelection(index);
        currentVariantId = selection.variantId || '';
        currentLengthValue = selection.lengthValue || '';
        currentSizeValue = selection.sizeValue || '';
      }

      function updateCurrentSelection(updates = {}, index = currentProductIndex) {
        const selection = getSelection(index);

        if (Object.prototype.hasOwnProperty.call(updates, 'variantId')) {
          selection.variantId = updates.variantId || '';
        }

        if (Object.prototype.hasOwnProperty.call(updates, 'lengthValue')) {
          selection.lengthValue = updates.lengthValue || '';
        }

        if (Object.prototype.hasOwnProperty.call(updates, 'sizeValue')) {
          selection.sizeValue = updates.sizeValue || '';
        }

        if (index === currentProductIndex) {
          syncCurrentSelection(index);
        }
      }

      function getActiveProduct() {
        return currentProducts[currentProductIndex] || currentProducts[0] || null;
      }

      function getActiveVariant(product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
        if (currentVariantId) {
          const matchedVariant = product.variants.find((variant) => String(variant.id) === String(currentVariantId));
          if (matchedVariant) return matchedVariant;
        }

        const resolvedVariant = resolveVariantFromSelections(product);
        if (resolvedVariant) return resolvedVariant;

        return product.variants.find((variant) => variantCanBeAdded(variant)) || product.variants[0] || null;
      }

      function variantCanBeAdded(variant) {
        if (!variant) return false;

        if (variant.available === true) return true;

        if (Number(variant.inventory_quantity) > 0) return true;

        if (variant.inventory_policy === 'continue') return true;

        if (variant.inventory_management && variant.inventory_policy !== 'continue') {
          return Number(variant.inventory_quantity) > 0;
        }

        if (variant.available === false) return false;

        return true;
      }

      function getSizeChoices(product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length || product.has_only_default_variant) {
          return { optionIndex: -1, values: [] };
        }

        const optionIndex = findSizeOptionIndex(product);
        if (optionIndex < 0) {
          return { optionIndex: -1, values: [] };
        }

        const map = new Map();

        const lengthOptionIndex = findLengthOptionIndex(product);

        product.variants.forEach((variant) => {
          if (lengthOptionIndex >= 0 && currentLengthValue && String(getOptionValue(variant, lengthOptionIndex) || '').trim() !== currentLengthValue) {
            return;
          }

          const value = String(getOptionValue(variant, optionIndex) || '').trim();
          if (!value) return;

          if (!map.has(value)) {
            map.set(value, {
              label: value,
              variantId: variant.id,
              available: variantCanBeAdded(variant)
            });
          } else if (variantCanBeAdded(variant)) {
            map.set(value, {
              label: value,
              variantId: variant.id,
              available: true
            });
          }
        });

        return { optionIndex, values: Array.from(map.values()) };
      }

      function getLengthChoices(product) {
        if (!product || !Array.isArray(product.variants) || !product.variants.length || product.has_only_default_variant) {
          return { optionIndex: -1, values: [] };
        }

        const optionIndex = findLengthOptionIndex(product);
        if (optionIndex < 0) {
          return { optionIndex: -1, values: [] };
        }

        const map = new Map();

        product.variants.forEach((variant) => {
          const value = String(getOptionValue(variant, optionIndex) || '').trim();
          if (!value) return;

          if (!map.has(value)) {
            map.set(value, {
              label: value,
              value,
              available: variantCanBeAdded(variant)
            });
          } else if (variantCanBeAdded(variant)) {
            map.set(value, {
              label: value,
              value,
              available: true
            });
          }
        });

        return { optionIndex, values: Array.from(map.values()) };
      }

      function resolveVariantFromSelections(product) {
        if (!product || !Array.isArray(product.variants)) return null;

        const sizeOptionIndex = findSizeOptionIndex(product);
        const lengthOptionIndex = findLengthOptionIndex(product);

        return product.variants.find((variant) => {
          if (lengthOptionIndex >= 0 && currentLengthValue && String(getOptionValue(variant, lengthOptionIndex) || '').trim() !== currentLengthValue) {
            return false;
          }

          if (sizeOptionIndex >= 0 && currentSizeValue && String(getOptionValue(variant, sizeOptionIndex) || '').trim() !== currentSizeValue) {
            return false;
          }

          return variantCanBeAdded(variant);
        }) || product.variants.find((variant) => {
          if (lengthOptionIndex >= 0 && currentLengthValue && String(getOptionValue(variant, lengthOptionIndex) || '').trim() !== currentLengthValue) {
            return false;
          }

          if (sizeOptionIndex >= 0 && currentSizeValue && String(getOptionValue(variant, sizeOptionIndex) || '').trim() !== currentSizeValue) {
            return false;
          }

          return true;
        }) || null;
      }

      function renderSizeLabel(sizeData, lengthPrefix) {
        if (!sizeLabelEl) return;

        const sizes = sizeData && Array.isArray(sizeData.values) ? sizeData.values : [];
        const selectedSize = sizes.find((size) => String(size.label) === String(currentSizeValue));

        if (lengthPrefix) {
          const labelText = selectedSize && selectedSize.label
            ? `<strong>${escapeHtml(lengthPrefix)}</strong> - ${escapeHtml(selectedSize.label)}`
            : `<strong>${escapeHtml(lengthPrefix)}</strong> - SELECT SIZE:`;
          sizeLabelEl.innerHTML = `<span>${labelText}</span>`
            + '<button type="button" class="athlete-styles__length-back" data-athlete-length-back aria-label="Change length">'
            + '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path d="M19.207 6.207a1 1 0 0 0-1.414-1.414L12 10.586 6.207 4.793a1 1 0 0 0-1.414 1.414L10.586 12l-5.793 5.793a1 1 0 1 0 1.414 1.414L12 13.414l5.793 5.793a1 1 0 0 0 1.414-1.414L13.414 12l5.793-5.793z" fill="currentColor"/></svg>'
            + '</button>';
        } else {
          sizeLabelEl.innerHTML = selectedSize && selectedSize.label
            ? `<span>SIZE: <strong>${escapeHtml(selectedSize.label)}</strong></span>`
            : '<span>SIZE</span>';
        }
      }

      function renderLengthLabel(lengthData) {
        if (!lengthLabelEl) return;

        const lengths = lengthData && Array.isArray(lengthData.values) ? lengthData.values : [];
        const selectedLength = lengths.find((length) => String(length.label) === String(currentLengthValue));

        lengthLabelEl.innerHTML = selectedLength && selectedLength.label
          ? `LENGTH: <strong>${escapeHtml(selectedLength.label)}</strong>`
          : 'LENGTH';
      }

      function setStatus(message) {
        if (statusEl) statusEl.textContent = message || '';
      }

      function getOptionSummary(variant) {
        if (!variant || !Array.isArray(variant.options)) return '';

        return variant.options
          .filter((option) => option && String(option).toLowerCase() !== 'default title')
          .join(' / ');
      }

      function getAddedTotal() {
        return addedItems.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
      }

      function isProductAdded(productIndex) {
        return addedItems.some((item) => Number(item.productIndex) === Number(productIndex));
      }

      function getAddedItem(productIndex) {
        return addedItems.find((item) => Number(item.productIndex) === Number(productIndex)) || null;
      }

      function getAddedProductCount() {
        return new Set(addedItems.map((item) => Number(item.productIndex))).size;
      }

      function getNextUnaddedProductIndex() {
        for (let index = currentProductIndex + 1; index < currentProducts.length; index += 1) {
          if (!isProductAdded(index)) return index;
        }

        for (let index = 0; index < currentProducts.length; index += 1) {
          if (!isProductAdded(index)) return index;
        }

        return -1;
      }

      function showCartLink() {
        if (!cartLink) return;

        const allProductsAdded = currentProducts.length > 0 && getAddedProductCount() >= currentProducts.length;

        finalCartLinkVisible = true;
        cartLink.classList.toggle('is-button', allProductsAdded);
        cartLink.classList.toggle('is-checkout', allProductsAdded);
        cartLink.innerHTML = allProductsAdded
          ? 'VIEW CART &amp; CHECKOUT'
          : `VIEW CART (TOTAL: <span class="athlete-styles__money">${escapeHtml(moneyText(typeof cartTotalCents === 'number' ? cartTotalCents : getAddedTotal()))}</span>)`;
        cartLink.href = getCartUrl();
        cartLink.hidden = false;
      }

      function hideCartLink() {
        if (!cartLink) return;

        finalCartLinkVisible = false;
        cartLink.classList.remove('is-button');
        cartLink.classList.remove('is-checkout');
        cartLink.hidden = true;
        cartLink.textContent = 'VIEW CART';
        cartLink.href = getCartUrl();
      }

      function clearFinalCartLinkTimer() {
        if (!finalCartLinkTimer) return;

        window.clearTimeout(finalCartLinkTimer);
        finalCartLinkTimer = null;
      }

      function openThemeCart(event) {
        if (event) event.preventDefault();

        if (cartLink && cartLink.classList.contains('is-checkout')) {
          window.location.href = getCartUrl();
          return;
        }

        document.dispatchEvent(new CustomEvent('cart:build'));
        closeDrawer();

        window.requestAnimationFrame(() => {
          if (document.getElementById('CartDrawer')) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          } else {
            window.location.href = getCartUrl();
          }
        });
      }

      function resetDrawerSelections() {
        currentProductIndex = 0;
        currentVariantId = '';
        currentLengthValue = '';
        currentSizeValue = '';
        selectionByProductIndex = {};
        addedItems = [];
        renderedProductMediaKey = '';
        clearFinalCartLinkTimer();
        hideCartLink();
        setStatus('');
        renderDrawer();
      }

      function updateClearAllVisibility() {
        if (!clearAllBtn) return;

        clearAllBtn.hidden = addedItems.length === 0;
      }

      function handleRemoveAddedItem(itemToRemove = null) {
        const addedItem = itemToRemove || getAddedItem(currentProductIndex);
        if (!addedItem) return Promise.resolve();

        const cartChangeUrl = window.theme && theme.routes && theme.routes.cartChange ? theme.routes.cartChange : '/cart/change.js';

        addBtn.disabled = true;
        addBtn.textContent = 'REMOVING...';
        setStatus('');

        return fetchCart()
          .then((cart) => {
            const matchingItem = Array.isArray(cart && cart.items)
              ? cart.items.find((item) => String(item.variant_id) === String(addedItem.variantId))
              : null;

            if (!matchingItem) return cart;

            return fetch(cartChangeUrl, {
              method: 'POST',
              credentials: 'same-origin',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json'
              },
              body: JSON.stringify({
                id: matchingItem.key,
                quantity: 0
              })
            }).then((response) => response.json().then((data) => {
              if (!response.ok) {
                throw new Error((data && data.description) || 'Unable to remove item.');
              }

              return data;
            }));
          })
          .then(() => fetchCart())
          .then((cart) => {
            addedItems = addedItems.filter((item) => String(item.variantId) !== String(addedItem.variantId));
            updateCurrentSelection({
              variantId: '',
              lengthValue: '',
              sizeValue: ''
            }, Number(addedItem.productIndex));
            refreshCartUi(cart);
            finalCartLinkVisible = addedItems.length > 0;
            setStatus('');
            renderDrawer();
          })
          .catch((error) => {
            setStatus(error.message || 'Unable to remove item.');
            renderProduct();
          });
      }

      function updateCartBubble(count) {
        document.querySelectorAll('.cart-link__bubble-num').forEach((el) => {
          el.textContent = count > 0 ? count : '';
        });

        document.querySelectorAll('.cart-link__bubble').forEach((el) => {
          el.classList.toggle('cart-link__bubble--visible', count > 0);
        });
      }

      function fetchCart() {
        const cartUrl = window.theme && theme.routes && theme.routes.cart ? theme.routes.cart : '/cart.js';

        return fetch(cartUrl, {
          credentials: 'same-origin',
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        }).then((response) => response.json());
      }

      function refreshCartUi(cart) {
        if (cart && typeof cart.total_price === 'number') {
          cartTotalCents = cart.total_price;
        }

        if (cart && typeof cart.item_count === 'number') {
          updateCartBubble(cart.item_count);
        }

    document.dispatchEvent(new CustomEvent('cart:build'));
    document.dispatchEvent(new CustomEvent('cart:updated', {
      detail: { cart }
    }));

    if (window.theme && theme.cart && typeof theme.cart.getCart === 'function') {
      theme.cart.getCart().then((updatedCart) => {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: updatedCart }
        }));
      }).catch(() => {});
    }
  }

      function renderProductMedia(product, activeVariant) {
        if (!productMedia) return;

        const images = getProductImages(product, activeVariant);
        const mediaKey = `${product && product.id ? product.id : ''}|${images.join('|')}`;
        if (mediaKey && mediaKey === renderedProductMediaKey) return;

        if (!images.length) {
          renderedProductMediaKey = mediaKey;
          renderedProductMediaToken += 1;
          productMedia.querySelectorAll('[data-athlete-product-slide]').forEach((slide) => slide.remove());
          resetMediaState();
          if (productPlaceholder) {
            productPlaceholder.hidden = false;
            productPlaceholder.style.display = '';
          }
          if (mediaProgress) mediaProgress.innerHTML = '';
          return;
        }

        renderedProductMediaToken += 1;
        {
          renderedProductMediaKey = mediaKey;
          productMedia.querySelectorAll('[data-athlete-product-slide]').forEach((slide) => slide.remove());

          if (productPlaceholder) {
            productPlaceholder.hidden = true;
            productPlaceholder.style.display = 'none';
          }

          productMedia.insertAdjacentHTML('beforeend', images.map((image, index) => {
            const isFullFitSlide = Boolean(product && product.athlete_image) && index === images.length - 1 && String(image) === String(product.athlete_image);
            const imageSrc = getSizedImageUrl(image, 640) || image;
            const imageSrcSet = getSizedImageSrcSet(image, [416, 640, 832]);
            const isDeferred = index >= 3;

            const imgSrcAttr = isDeferred ? '' : ` src="${escapeHtml(imageSrc)}"`;
            const imgSrcSetAttr = (!isDeferred && imageSrcSet) ? ` srcset="${imageSrcSet}"` : '';
            const dataSlideSrc = isDeferred ? ` data-slide-src="${escapeHtml(imageSrc)}"` : '';
            const dataSlideSrcset = (isDeferred && imageSrcSet) ? ` data-slide-srcset="${imageSrcSet}"` : '';
            const loadingAttr = isDeferred ? 'lazy' : (index === 0 ? 'eager' : 'lazy');
            const fetchpriorityAttr = isDeferred ? 'auto' : (index === 0 ? 'high' : 'auto');

            return `
            <a class="athlete-styles__product-slide${isFullFitSlide ? ' athlete-styles__product-slide--full-fit' : ''}" data-athlete-product-slide href="${escapeHtml(getSafeProductUrl(product.url))}" aria-label="View ${escapeHtml(product.title || 'product')} ${isFullFitSlide ? 'full fit image' : `image ${index + 1}`}">
              <img class="athlete-styles__product-image${isFullFitSlide ? ' athlete-styles__product-image--full-fit' : ''}"${imgSrcAttr}${imgSrcSetAttr}${dataSlideSrc}${dataSlideSrcset} sizes="(max-width: 749px) calc(100vw - 32px), 416px" alt="${escapeHtml(product.title || '')}" loading="${loadingAttr}" fetchpriority="${fetchpriorityAttr}" decoding="async" width="1200" height="660">
            </a>
          `;
          }).join(''));

          if (mediaProgress) {
            mediaProgress.innerHTML = images.map((_, index) => `<span class="${index === 0 ? 'is-active' : ''}"></span>`).join('');
          }

          cacheMediaSlides();
          productMedia.scrollLeft = 0;
          updateMediaArrows();
          updateMediaProgress();
        }
      }

      function renderProduct() {
        const product = getActiveProduct();
        if (!product) {
          if (productMedia) productMedia.querySelectorAll('[data-athlete-product-slide]').forEach((slide) => slide.remove());
          resetMediaState();
          if (productPlaceholder) {
            productPlaceholder.hidden = false;
            productPlaceholder.style.display = '';
          }
          if (mediaProgress) mediaProgress.innerHTML = '';
          updateMediaArrows();
          if (vendorEl) vendorEl.textContent = '';
          if (titleEl) { titleEl.textContent = ''; titleEl.setAttribute('aria-hidden', 'true'); }
          if (reviewsEl) reviewsEl.innerHTML = '';
          if (priceEl) priceEl.textContent = '';
          if (lengthLabelEl) lengthLabelEl.hidden = true;
          if (lengthsEl) lengthsEl.innerHTML = '';
          if (lengthsEl) {
            lengthsEl.hidden = true;
            lengthsEl.removeAttribute('data-size-count');
          }
          if (sizeLabelEl) sizeLabelEl.hidden = true;
          if (sizesEl) sizesEl.innerHTML = '';
          if (sizesEl) {
            sizesEl.hidden = true;
            sizesEl.classList.remove('is-carousel');
            sizesEl.removeAttribute('data-size-count');
          }
          if (addBtn) {
            addBtn.hidden = false;
            addBtn.disabled = true;
            addBtn.textContent = 'ADD TO CART';
          }
          hideCartLink();
          return;
        }

        const lengthData = getLengthChoices(product);
        const sizeData = getSizeChoices(product);
        const hasLengths = lengthData.values.length > 0;
        const hasSizes = sizeData.values.length > 0;
        const activeVariant = getActiveVariant(product);

        if (vendorEl) vendorEl.textContent = product.vendor || '';
        if (titleEl) { titleEl.textContent = product.title || ''; if (product.title) { titleEl.removeAttribute('aria-hidden'); } else { titleEl.setAttribute('aria-hidden', 'true'); } }
        if (reviewsEl) {
          reviewsEl.innerHTML = getReviewSummaryMarkup(product.review_badge || '');
        }
        if (priceEl) {
          const priceValue = activeVariant ? activeVariant.price : (product.variants && product.variants[0] ? product.variants[0].price : 0);
          const compareValue = activeVariant && activeVariant.compare_at_price && Number(activeVariant.compare_at_price) > Number(priceValue) ? activeVariant.compare_at_price : 0;
          priceEl.innerHTML = compareValue
            ? `<s>${escapeHtml(moneyText(compareValue))}</s> ${escapeHtml(moneyText(priceValue))}`
            : escapeHtml(moneyText(priceValue));
        }

        if (fullLink) fullLink.href = getSafeProductUrl(product.url);
        renderProductMedia(product, activeVariant);

        const lengthThenSize = hasLengths && hasSizes;
        const selectedLengthLabel = lengthThenSize
          ? ((lengthData.values.find((l) => String(l.value) === String(currentLengthValue)) || {}).label || currentLengthValue)
          : '';

        if (lengthsEl) {
          if (!hasLengths) {
            lengthsEl.innerHTML = '';
            lengthsEl.hidden = true;
            lengthsEl.removeAttribute('data-size-count');
            if (lengthLabelEl) lengthLabelEl.hidden = true;
          } else {
            const showLength = !lengthThenSize || !currentLengthValue;
            lengthsEl.hidden = !showLength;
            if (showLength) {
              lengthsEl.dataset.sizeCount = String(lengthData.values.length);
              lengthsEl.innerHTML = lengthData.values.map((length) => {
                const isSelected = String(currentLengthValue) === String(length.value);
                return `<button type="button" class="athlete-styles__size${isSelected ? ' is-selected' : ''}" data-athlete-length data-option-value="${escapeHtml(length.value)}" ${length.available ? '' : 'disabled'}>${escapeHtml(length.label)}</button>`;
              }).join('');
            } else {
              lengthsEl.innerHTML = '';
              lengthsEl.removeAttribute('data-size-count');
            }
            if (lengthLabelEl) {
              if (lengthThenSize) {
                lengthLabelEl.hidden = !showLength;
                if (showLength) lengthLabelEl.innerHTML = 'SELECT LENGTH:';
              } else {
                lengthLabelEl.hidden = false;
                renderLengthLabel(lengthData);
              }
            }
          }
        }

        if (sizesEl) {
          if (!hasSizes) {
            sizesEl.innerHTML = '';
            sizesEl.hidden = true;
            sizesEl.removeAttribute('data-size-count');
            if (sizeLabelEl) sizeLabelEl.hidden = true;
          } else {
            const showSize = !lengthThenSize || currentLengthValue;
            sizesEl.hidden = !showSize;
            if (sizeLabelEl) {
              sizeLabelEl.hidden = !showSize;
              if (showSize) renderSizeLabel(sizeData, selectedLengthLabel);
            }
            if (showSize) {
              sizesEl.innerHTML = sizeData.values.map((size) => {
                const isSelected = String(currentSizeValue) === String(size.label);
                return `<button type="button" class="athlete-styles__size${isSelected ? ' is-selected' : ''}" data-athlete-size data-option-value="${escapeHtml(size.label)}" ${size.available ? '' : 'disabled'}>${escapeHtml(size.label)}</button>`;
              }).join('');
            } else {
              sizesEl.innerHTML = '';
            }
          }
        }

        if (addBtn) {
          const activeAvailable = variantCanBeAdded(activeVariant);
          const allProductsAdded = currentProducts.length > 0 && getAddedProductCount() >= currentProducts.length;
          const addedItem = getAddedItem(currentProductIndex);
          const productAlreadyAdded = isProductAdded(currentProductIndex);

          addBtn.hidden = allProductsAdded && !productAlreadyAdded;
          addBtn.disabled = false;

          if (!hasSizes && !hasLengths) {
            const activeVariantId = activeVariant ? String(activeVariant.id) : '';
            currentVariantId = activeVariantId;
            updateCurrentSelection({ variantId: activeVariantId });
            addBtn.disabled = !currentVariantId || !activeAvailable;
          } else {
            addBtn.disabled = !currentVariantId || !activeAvailable || (hasLengths && !currentLengthValue) || (hasSizes && !currentSizeValue);
          }

          addBtn.classList.remove('is-continue');
          if (allProductsAdded) {
            addBtn.classList.remove('is-view-cart');
            addBtn.classList.add('is-continue');
            addBtn.hidden = false;
            addBtn.disabled = false;
            addBtn.textContent = 'CONTINUE SHOPPING';
          } else if (!activeAvailable) {
            addBtn.classList.remove('is-view-cart');
            addBtn.textContent = 'SOLD OUT';
          } else if (productAlreadyAdded) {
            addBtn.classList.remove('is-view-cart');
            addBtn.disabled = false;
            addBtn.textContent = `REMOVE ${addedItem && addedItem.meta ? addedItem.meta : 'ITEM'}`;
          } else {
            addBtn.classList.remove('is-view-cart');
            addBtn.innerHTML = currentVariantId || (!hasSizes && !hasLengths)
              ? `ADD TO CART - <span class="athlete-styles__money">${escapeHtml(moneyText(activeVariant ? activeVariant.price : 0))}</span>`
              : hasLengths && !currentLengthValue
                ? 'SELECT A LENGTH'
                : 'SELECT A SIZE';
          }
        }

        if (finalCartLinkVisible && addedItems.length > 0) {
          showCartLink();
        } else {
          hideCartLink();
        }

        updateClearAllVisibility();
      }

      function renderThumbs() {
        if (!thumbs) return;

        thumbs.classList.toggle('has-added-items', addedItems.length > 0);

        thumbs.innerHTML = currentProducts.map((product, index) => {
          const thumbBaseSrc = product && Array.isArray(product.images) && product.images.length ? product.images[0] : getProductImage(product, null);
          const thumbSrc = getSizedImageUrl(thumbBaseSrc, 320) || thumbBaseSrc;
          const thumbSrcSet = thumbBaseSrc
            ? `${escapeHtml(getSizedImageUrl(thumbBaseSrc, 160) || thumbBaseSrc)} 160w, ${escapeHtml(getSizedImageUrl(thumbBaseSrc, 240) || thumbBaseSrc)} 240w, ${escapeHtml(getSizedImageUrl(thumbBaseSrc, 320) || thumbBaseSrc)} 320w, ${escapeHtml(getSizedImageUrl(thumbBaseSrc, 480) || thumbBaseSrc)} 480w`
            : '';
          const addedItem = addedItems.find((item) => Number(item.productIndex) === index);
          return `<button type="button" class="athlete-styles__thumb${index === currentProductIndex ? ' is-active' : ''}${addedItem ? ' is-added' : ''}" data-athlete-thumb data-index="${index}" aria-label="${escapeHtml(product.title || 'Product')}" aria-pressed="${index === currentProductIndex ? 'true' : 'false'}">${thumbSrc ? `<img src="${escapeHtml(thumbSrc)}"${thumbSrcSet ? ` srcset="${thumbSrcSet}" sizes="72px"` : ''} alt="${escapeHtml(product.title || '')}" loading="${index === currentProductIndex ? 'eager' : 'lazy'}" fetchpriority="${index === currentProductIndex ? 'high' : 'auto'}" decoding="async" width="320" height="320">` : ''}${addedItem ? `<span class="athlete-styles__thumb-added">✓ ${escapeHtml(addedItem.meta || '')}</span>` : ''}</button>`;
        }).join('');
      }

      function updateThumbState() {
        if (!thumbs) return;

        thumbs.classList.toggle('has-added-items', addedItems.length > 0);

        thumbs.querySelectorAll('[data-athlete-thumb]').forEach((thumb, index) => {
          const addedItem = addedItems.find((item) => Number(item.productIndex) === index);
          thumb.classList.toggle('is-active', index === currentProductIndex);
          thumb.classList.toggle('is-added', Boolean(addedItem));
          thumb.setAttribute('aria-pressed', index === currentProductIndex ? 'true' : 'false');
        });
      }

      function renderDrawer() {
        if (!drawer) return;

        renderThumbs();
        renderProduct();
      }

      function enableMouseDragScroll(scroller, options = {}) {
        if (!scroller || scroller.dataset.athleteDragScrollBound === 'true') return;

        const clickSelector = options.clickSelector || '';
        let isPointerDown = false;
        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;

        scroller.dataset.athleteDragScrollBound = 'true';

        scroller.addEventListener('mousedown', (event) => {
          if (event.button !== 0) return;

          isPointerDown = true;
          isDragging = false;
          startX = event.clientX;
          startScrollLeft = scroller.scrollLeft;
        });

        window.addEventListener('mousemove', (event) => {
          if (!isPointerDown) return;

          const deltaX = event.clientX - startX;
          if (!isDragging && Math.abs(deltaX) > 4) {
            isDragging = true;
          }

          if (!isDragging) return;

          scroller.scrollLeft = startScrollLeft - deltaX;
          event.preventDefault();
        });

        window.addEventListener('mouseup', () => {
          if (!isPointerDown) return;

          isPointerDown = false;

          window.setTimeout(() => {
            isDragging = false;
          }, 0);
        });

        if (clickSelector) {
          scroller.addEventListener('click', (event) => {
            if (!isDragging) return;

            const clickTarget = event.target.closest(clickSelector);
            if (!clickTarget) return;

            event.preventDefault();
            event.stopPropagation();
          }, true);
        }
      }

      if (productMedia && mediaProgress) {
        productMedia.addEventListener('scroll', scheduleMediaScrollUpdate, { passive: true });
      }

      if (mediaPrevBtn && productMedia) {
        mediaPrevBtn.addEventListener('click', () => {
          productMedia.scrollBy({ left: -getMediaScrollStep(), behavior: 'smooth' });
        });
      }

      if (mediaNextBtn && productMedia) {
        mediaNextBtn.addEventListener('click', () => {
          productMedia.scrollBy({ left: getMediaScrollStep(), behavior: 'smooth' });
        });
      }

      if (cardsPrevBtn && cardsScroller) {
        cardsPrevBtn.addEventListener('click', () => {
          cardsScroller.scrollBy({ left: -getCardsScrollStep(), behavior: 'smooth' });
        });
      }

      if (cardsNextBtn && cardsScroller) {
        cardsNextBtn.addEventListener('click', () => {
          cardsScroller.scrollBy({ left: getCardsScrollStep(), behavior: 'smooth' });
        });
      }

      window.addEventListener('resize', scheduleResizeUpdate, { passive: true });

      enableMouseDragScroll(cardsScroller, {
        clickSelector: '[data-athlete-open]'
      });

      enableMouseDragScroll(productMedia, {
        clickSelector: '[data-athlete-product-slide]'
      });

      if (cardsScroller) {
        cardsScroller.addEventListener('scroll', updateCardsArrows, { passive: true });
      }

      updateCardsArrows();

      function openDrawer(products, trigger) {
        currentProducts = Array.isArray(products) ? products.filter(Boolean) : [];
        currentProductIndex = 0;
        currentVariantId = '';
        currentLengthValue = '';
        currentSizeValue = '';
        selectionByProductIndex = {};
        addedItems = [];
        renderedProductMediaKey = '';
        clearFinalCartLinkTimer();
        hideCartLink();
        lastTrigger = trigger || null;

        if (!currentProducts.length) return;

        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        lockScroll();
        setStatus('');
        renderDrawer();

        window.requestAnimationFrame(() => {
          const closeButton = drawer.querySelector('[data-athlete-close]');
          if (closeButton && typeof closeButton.focus === 'function') {
            closeButton.focus({ preventScroll: true });
          }
        });
      }

      function closeDrawer() {
        if (!drawer) return;

        clearFinalCartLinkTimer();
        hideCartLink();
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        unlockScroll();
        setStatus('');
        currentProducts = [];
        currentProductIndex = 0;
        currentVariantId = '';
        currentLengthValue = '';
        currentSizeValue = '';
        selectionByProductIndex = {};
        addedItems = [];
        renderedProductMediaKey = '';
        renderThumbs();
        renderProduct();

        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus({ preventScroll: true });
        }
      }

      function getSelectedVariant(product) {
        if (!product || !Array.isArray(product.variants)) return null;
        return product.variants.find((variant) => String(variant.id) === String(currentVariantId)) || null;
      }

      function handleAddToCart() {
        if (addBtn && addBtn.classList.contains('is-continue')) {
          closeDrawer();
          return;
        }
        const product = getActiveProduct();
        const variant = getSelectedVariant(product) || getActiveVariant(product);

        if (!product || !variant) return;
        if (isProductAdded(currentProductIndex)) {
          handleRemoveAddedItem();
          return;
        }

        clearFinalCartLinkTimer();

        if (!variant.available) {
          setStatus('This item is sold out.');
          renderProduct(false);
          return;
        }

        if (currentProducts.length > 0 && getAddedProductCount() >= currentProducts.length) {
          openThemeCart();
          return;
        }

        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';
        setStatus('');

        const cartAddUrl = window.theme && theme.routes && theme.routes.cartAdd ? theme.routes.cartAdd : '/cart/add.js';

        fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: new URLSearchParams({ id: variant.id, quantity: 1 }).toString()
        })
          .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
          .then(({ ok, data }) => {
            if (!ok || data.status === 422) {
              throw new Error((data && data.description) || 'Unable to add item.');
            }

            addedItems.push({
              productIndex: currentProductIndex,
              variantId: variant.id,
              title: product.title || data.product_title || data.title || 'Product',
              meta: getOptionSummary(variant),
              price: variant.price || data.final_price || data.price || 0,
              image: getProductImage(product, variant)
            });

            updateClearAllVisibility();

            return fetchCart();
          })
          .then((cart) => {
            refreshCartUi(cart);
            finalCartLinkVisible = addedItems.length > 0;

            if (getAddedProductCount() < currentProducts.length) {
              const nextProductIndex = getNextUnaddedProductIndex();
              if (nextProductIndex >= 0) {
                currentProductIndex = nextProductIndex;
              }
              syncCurrentSelection(currentProductIndex);
              if (sizesEl) sizesEl.scrollLeft = 0;
              setStatus('');
              renderDrawer();
            } else {
              syncCurrentSelection(currentProductIndex);
              if (sizesEl) sizesEl.scrollLeft = 0;
              setStatus('');
              renderDrawer();
            }
          })
          .catch((error) => {
            addBtn.disabled = false;
            setStatus(error.message || 'Unable to add item.');
            renderProduct();
          });
      }

      function handleClearAll() {
        if (!addedItems.length) {
          resetDrawerSelections();
          return;
        }

        const cartChangeUrl = window.theme && theme.routes && theme.routes.cartChange ? theme.routes.cartChange : '/cart/change.js';
        const variantIdsToRemove = Array.from(new Set(addedItems.map((item) => String(item.variantId)).filter(Boolean)));

        if (clearAllBtn) clearAllBtn.disabled = true;
        setStatus('');

        fetchCart()
          .then((cart) => {
            const matchingItems = Array.isArray(cart && cart.items)
              ? cart.items.filter((item) => variantIdsToRemove.includes(String(item.variant_id)))
              : [];

            return matchingItems.reduce((promise, item) => {
              return promise.then(() => {
                return fetch(cartChangeUrl, {
                  method: 'POST',
                  credentials: 'same-origin',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    id: item.key,
                    quantity: 0
                  })
                }).then((response) => response.json().then((data) => {
                  if (!response.ok) {
                    throw new Error((data && data.description) || 'Unable to clear selections.');
                  }

                  return data;
                }));
              });
            }, Promise.resolve());
          })
          .then(() => fetchCart())
          .then((cart) => {
            refreshCartUi(cart);
            resetDrawerSelections();
          })
          .catch((error) => {
            setStatus(error.message || 'Unable to clear selections.');
          })
          .finally(() => {
            if (clearAllBtn) clearAllBtn.disabled = false;
          });
      }

      // Prewarm drawer images as a card nears the viewport, so the
      // thumbnail row appears instantly on click instead of downloading
      // on open. Deduped (unobserve + shared guard), idle-scheduled,
      // and skipped on save-data/2g. Only the thumbnail size is prewarmed
      // via observer (hero-size is prewarmed by warmOnIntent for index 0).
      // Observation starts only after the LCP hero gate opens: before CSS and
      // images settle, collapsed layout makes every section look "near the
      // viewport", so an ungated observer would warm slide images for every
      // card during the LCP window.
      const heroGate = (window.DFYNE && window.DFYNE.heroReady) || Promise.resolve();
      const prewarmConn = navigator.connection;
      const prewarmSkip = prewarmConn && (prewarmConn.saveData || /(?:^|-)2g$/.test(prewarmConn.effectiveType || ''));
      const prewarmObserver = (!prewarmSkip && 'IntersectionObserver' in window)
        ? new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              prewarmObserver.unobserve(entry.target);
              const shell = entry.target;
              if (shell.dataset.athletePrewarmed === 'true') return;
              const prods = shell.__athleteParsed || parseJsonScript(shell.querySelector('[data-athlete-products]'));
              if (!Array.isArray(prods) || !prods.length) return;
              shell.__athleteParsed = prods;
              const warm = () => {
                prods.forEach((product) => {
                  const imgs = getProductImages(product, null);
                  if (!imgs.length) return;
                  preloadResponsiveImage(imgs[0], ATHLETE_THUMB_WIDTHS, '72px');
                });
              };
              shell.dataset.athletePrewarmed = 'true';
              if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 300 });
              else setTimeout(warm, 300);
            });
          }, { rootMargin: '300px 0px' })
        : null;

      cards.forEach((card) => {
        const cardShell = card.closest('.athlete-styles__card-shell');
        const dataScript = cardShell ? cardShell.querySelector('[data-athlete-products]') : null;
        const openButton = card;

        if (openButton) {
          const warmOnIntent = () => {
            if (!cardShell || cardShell.dataset.athletePrewarmed === 'true') return;
            cardShell.dataset.athletePrewarmed = 'true';
            const prods = cardShell.__athleteParsed || parseJsonScript(dataScript);
            if (!Array.isArray(prods) || !prods.length) return;
            cardShell.__athleteParsed = prods;
            prods.forEach((product, index) => {
              const imgs = getProductImages(product, null);
              if (!imgs.length) return;
              preloadResponsiveImage(imgs[0], ATHLETE_THUMB_WIDTHS, '72px');
              if (index === 0) preloadResponsiveImage(imgs[0], ATHLETE_HERO_WIDTHS, ATHLETE_HERO_SIZES);
            });
          };
          openButton.addEventListener('pointerdown', warmOnIntent, { passive: true });
          openButton.addEventListener('touchstart', warmOnIntent, { passive: true });

          openButton.addEventListener('click', () => {
            const prods = (cardShell && cardShell.__athleteParsed) || parseJsonScript(dataScript);
            if (cardShell) cardShell.__athleteParsed = prods;
            openDrawer(prods, openButton);
          });
        }

        if (prewarmObserver && cardShell && dataScript) {
          heroGate.then(() => prewarmObserver.observe(cardShell));
        }
      });

        if (thumbs) {
          thumbs.addEventListener('click', (event) => {
            const thumbButton = event.target.closest('[data-athlete-thumb]');
            if (!thumbButton || !thumbs.contains(thumbButton)) return;

            const index = Number(thumbButton.dataset.index || 0);
            if (Number.isNaN(index) || !currentProducts[index]) return;

            currentProductIndex = index;
            syncCurrentSelection(index);
            setStatus('');
            updateThumbState();
            renderProduct();
          });
        }

      if (lengthsEl) {
        lengthsEl.addEventListener('click', (event) => {
          const lengthButton = event.target.closest('[data-athlete-length]');
          if (!lengthButton || lengthButton.disabled) return;

          updateCurrentSelection({
            lengthValue: lengthButton.dataset.optionValue || '',
            sizeValue: '',
            variantId: ''
          });
          const product = getActiveProduct();
          const resolvedVariant = resolveVariantFromSelections(product);
          updateCurrentSelection({ variantId: resolvedVariant ? String(resolvedVariant.id) : '' });
          updateClearAllVisibility();
          renderProduct();
        });
      }

      if (sizeLabelEl) {
        sizeLabelEl.addEventListener('click', (event) => {
          const backButton = event.target.closest('[data-athlete-length-back]');
          if (!backButton) return;

          updateCurrentSelection({ lengthValue: '', sizeValue: '', variantId: '' });
          updateClearAllVisibility();
          renderProduct();
        });
      }

      if (sizesEl) {
        sizesEl.addEventListener('click', (event) => {
          const sizeButton = event.target.closest('[data-athlete-size]');
          if (!sizeButton || sizeButton.disabled) return;

          updateCurrentSelection({
            sizeValue: sizeButton.dataset.optionValue || '',
            variantId: ''
          });
          const product = getActiveProduct();
          const resolvedVariant = resolveVariantFromSelections(product);
          updateCurrentSelection({ variantId: resolvedVariant ? String(resolvedVariant.id) : '' });
          updateClearAllVisibility();
          renderProduct();
        });
      }

      if (addBtn) {
        addBtn.addEventListener('click', handleAddToCart);
      }

      if (cartLink) {
        cartLink.addEventListener('click', openThemeCart);
      }

      if (clearAllBtn) {
        clearAllBtn.addEventListener('click', handleClearAll);
      }

      if (drawer) {
        drawer.addEventListener('click', (event) => {
          const closeTarget = event.target.closest('[data-athlete-close]');
          if (closeTarget) {
            closeDrawer();
          }
        });

        drawer.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            closeDrawer();
            return;
          }

          if (event.key !== 'Tab' || drawer.getAttribute('aria-hidden') === 'true') return;

          const focusableElements = getFocusableElements();
          if (!focusableElements.length) return;

          const firstElement = focusableElements[0];
          const lastElement = focusableElements[focusableElements.length - 1];

          if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
          } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
          }
        });
      }
    }

    function lockScroll() {
      window.__athleteStylesLockCount = (window.__athleteStylesLockCount || 0) + 1;
      document.documentElement.classList.add('athlete-styles-lock');
      document.body.classList.add('athlete-styles-lock');
    }

    function unlockScroll() {
      window.__athleteStylesLockCount = Math.max(0, (window.__athleteStylesLockCount || 0) - 1);

      if (window.__athleteStylesLockCount === 0) {
        document.documentElement.classList.remove('athlete-styles-lock');
        document.body.classList.remove('athlete-styles-lock');
      }
    }

    function init() {
      document.querySelectorAll('[data-athlete-section-id]').forEach(initSection);

      if (!window.__athleteStylesSectionListener) {
        window.__athleteStylesSectionListener = true;
        document.addEventListener('shopify:section:load', (event) => {
          const sectionEl = document.getElementById('AthleteStyles-' + event.detail.sectionId);
          if (sectionEl) initSection(sectionEl);
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
})();
